import React, { useRef } from 'react';
import { StepProps } from '../../types/form';
import { useReferenceData } from '../../context/ReferenceDataContext';
import { FormField } from '../ui/FormField';
import { ToggleGroup } from '../ui/ToggleGroup';
import { OptionMultiSelect } from '../ui/OptionMultiSelect';
function BoolToggle({
  id,
  label,
  value,
  onChange,
  error
}: {
  id: string;
  label: string;
  value: boolean | null;
  onChange: (v: boolean) => void;
  error?: string;
}) {
  return <FormField id={id} label={label} error={error} data-id="element-45">
      <ToggleGroup value={value} onChange={onChange} error={!!error} data-id="element-46" />
    </FormField>;
}
export function ClaimsKnowledgeStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  const {
    lawyers,
    isLoading
  } = useReferenceData();
  return <div className="space-y-8" data-id="element-47">
      <div data-id="element-48">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-49">
          Claims & Knowledge Center
        </h2>
        <p className="text-sm text-muted-foreground" data-id="element-50">
          Configure claims access and knowledge center for this group.
        </p>
      </div>

      <div className="space-y-4" data-id="element-51">
        <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide" data-id="element-52">
          Claims
        </h3>

        <BoolToggle id="claimsSubmit" label="Can users submit claims?" value={formData.claimsSubmit} onChange={v => updateFormData({
        claimsSubmit: v,
        ...(v === false && {
          claimsEdit: false,
          claimsChangeStatus: false,
          claimsLawyerIds: []
        })
      })} error={errors.claimsSubmit} data-id="element-53" />
        

        {formData.claimsSubmit && <div className="space-y-4 pl-0 border-l-2 border-violet-blue/20 ml-1 pl-4" data-id="element-54">
            <BoolToggle id="claimsEdit" label="Can users edit claims?" value={formData.claimsEdit} onChange={v => updateFormData({
          claimsEdit: v
        })} data-id="element-55" />
          
            <BoolToggle id="claimsChangeStatus" label="Can users change claim status?" value={formData.claimsChangeStatus} onChange={v => updateFormData({
          claimsChangeStatus: v
        })} data-id="element-56" />
          
            <FormField id="claimsLawyerIds" label="Which Lawyers Handle Claims? (Optional)" hint="Leave empty to use platform defaults." data-id="element-57">
            
              <OptionMultiSelect options={lawyers} selectedValues={formData.claimsLawyerIds} onChange={vals => updateFormData({
            claimsLawyerIds: vals
          })} placeholder="Use platform defaults (none selected)" loading={isLoading} showSelectAll={false} searchable searchPlaceholder="Search lawyers by name or email..." data-id="element-58" />
            
            </FormField>
          </div>}
      </div>

      <div className="h-px bg-border" data-id="element-59" />

      <div className="space-y-4" data-id="element-60">
        <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide" data-id="element-61">
          Knowledge Center
        </h3>

        <BoolToggle id="hasKnowledgeCenter" label="Should the group have access to the Knowledge Center?" value={formData.hasKnowledgeCenter} onChange={v => updateFormData({
        hasKnowledgeCenter: v,
        ...(v === false && {
          knowledgeCenterCategoriesInput: ''
        })
      })} error={errors.hasKnowledgeCenter} data-id="element-62" />
        

        {formData.hasKnowledgeCenter && <div className="pl-0 border-l-2 border-violet-blue/20 ml-1 pl-4" data-id="element-63">
            <FormField id="knowledgeCenterCategoriesInput" label="Content Categories (Optional)" hint="Comma-separated category names. Leave empty to use admin platform defaults." data-id="element-64">
            
              <input type="text" value={formData.knowledgeCenterCategoriesInput} onChange={e => updateFormData({
            knowledgeCenterCategoriesInput: e.target.value
          })} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm" placeholder="e.g. Meeting Minutes, Bylaws & Rules, Insurance Documents" data-id="element-65" />
            
            </FormField>
          </div>}
      </div>
    </div>;
}